<template>
  <v-form>
    <v-layout wrap align-center>
      <DateTimePicker
        :errorMessages="dateStartErrors"
        titleDate="Fecha de inicio"
        titleTime="Hora de inicio"
        v-model="v.startDate.$model"
      ></DateTimePicker>
    </v-layout>
    <v-layout wrap align-center>
      <DateTimePicker
        :errorMessages="dateEndErrors"
        titleDate="Fecha de término"
        titleTime="Hora de término"
        v-model="v.endDate.$model"
      ></DateTimePicker>
    </v-layout>
  </v-form>
</template>

<script>
import moment from "moment";
import DateTimePicker from "./Tools/DateTimePicker";
import { required } from "vuelidate/lib/validators";
export default {
  props: ["value", "v"],
  components: {
    DateTimePicker
  },
  data: () => ({
    menu: {
      startD: false,
      startT: false,
      endD: false,
      endT: false
    },
    noticeForm: {}
  }),
  watch: {},
  computed: {
    dateStartErrors() {
      const errors = [];
      if (!this.v.startDate.$dirty) return errors;
      !this.v.startDate.required && errors.push("Fecha de inicio obligatoria");
      return errors;
    },
    dateEndErrors() {
      const errors = [];
      if (!this.v.endDate.$dirty) return errors;
      !this.v.endDate.validateDateEnd &&
        errors.push("La fecha final debe ser menor a la de inicio");
      return errors;
    }
  }
};
</script>

<style>
</style>
